angular.module('tgaAdmin').controller('QuestionListController', [
  '$scope',
  '$state',
  '$window',
  '$timeout',
  '$location',
  '$filter',
  'gameService',
  'playerListService',
  'assetService',
  'flashService',
  'Slug',
  'fileReader',
  'domainService',
  'modalService',
  'settingsService',
  'SSOProviderService',
  'questionListService',
  'languages',
  '$translate',
  function (
    $scope,
    $state,
    $window,
    $timeout,
    $location,
    $filter,
    gameService,
    playerListService,
    assetService,
    flashService,
    Slug,
    fileReader,
    domainService,
    modalService,
    settingsService,
    SSOProviderService,
    questionListService,
    languages,
    $translate,
  ) {
    $scope.showBack = true;
    $scope.questionTooltip = $filter('translate')('common.question_tooltip_html');
    $scope.data = {
      alerts: [],
      isOpen: [],
      limit: 15,
      allTranslations: angular.copy(languages),
      availableTranslations: angular.copy(languages),
      existingTranslations: [],
      selectedTranslation: null,
      activeTranslation: null,
      question_list_id: $state.params.question_list_id || null,
      questionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select',
        },
        {
          id: 'image',
          name: 'Image Match',
        },
        {
          id: 'text_input',
          name: 'Text Input',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
      ],
      triviaQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select',
        },
        {
          id: 'image',
          name: 'Image Match',
        },
        {
          id: 'text_input',
          name: 'Text Input',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
        {
          id: 'interstitial',
          name: 'Info Card',
        },
      ],
      scenariosQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice Question',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select Question',
        },
        {
          id: 'image',
          name: 'Image Match Question',
        },
        {
          id: 'text_input',
          name: 'Text Input Question',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
        {
          id: 'interstitial',
          name: 'Info Slide',
        },
      ],
      wbsQuestionTypes: [
        {
          // WBS rerranged & renamed
          id: 'image',
          name: 'Action Selection',
        },
        {
          id: 'poll',
          name: 'Scenario Option',
        },
        {
          id: 'interstitial',
          name: 'Scenario Intro/Consequence',
        },
        {
          id: 'multiple_choice',
          name: 'Something Unexpected Happens',
        },
      ],
      matchQuestionTypes: [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        },
        {
          id: 'multiple_select',
          name: 'Multiple Select',
        },
        {
          id: 'image',
          name: 'Image Match',
        },
        {
          id: 'text_input',
          name: 'Text Input',
        },
        {
          id: 'poll',
          name: 'Poll',
        },
      ],
      scrambleQuestionTypes: [
        {
          id: 'scramble_letter',
          name: 'Letter Scramble',
        },
        {
          id: 'scramble_sentence',
          name: 'Sentence Scramble',
        },
      ],
      customFieldOptions: {
        types: [
          {
            id: 'text',
            name: 'Text Input',
          },
          {
            id: 'dropdown',
            name: 'Dropdown',
          },
        ],
        condition: [
          {
            id: 'optional',
            name: 'Optional',
          },
          {
            id: 'required',
            name: 'Required',
          },
          {
            id: 'disabled',
            name: 'Disabled',
          },
        ],
        label: '',
      },
      yesno: [
        {
          id: true,
          name: 'Yes',
        },
        {
          id: false,
          name: 'No',
        },
      ],
      matchTypes: [
        {
          id: null,
          name: 'Exact',
        },
        {
          id: 'contains',
          name: 'Contains',
        },
        {
          id: 'starts_with',
          name: 'Starts With',
        },
        {
          id: 'ends_with',
          name: 'Ends With',
        },
        {
          id: 'inside',
          name: 'Inside',
        },
      ],
    };

    $scope.numeric = /^\d+$/;

    $scope.addMoreItems = function () {
      if (!$scope.loadMore && $scope.data.limit < $scope.viewmodel.questions.length) {
        $scope.loadMore = true;

        $timeout(() => {
          $scope.data.limit += 10;
          $scope.loadMore = false;
        }, 250);
      }
    };

    $scope.viewmodel = {
      name: null,
      language_id: 1,
      available_translations: [],
      game_type: 'trivia',
      questions: [],
      question_groups: [],
    };

    $scope.initialize = function () {
      if ($scope.data.question_list_id) {
        $scope.loading = true;

        questionListService
          .getQuestionList($scope.data.question_list_id)
          .then((questionList) => {
            $scope.viewmodel = questionList;
            $scope.actions.processGame($scope.viewmodel);
          })
          .catch((error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
          })
          .finally(() => {
            $scope.loading = false;
          });
      }

      $scope.actions.changeDefaultLanguage($scope.viewmodel.language_id);
    };

    $scope.actions = {
      deleteList() {
        modalService
          .showModal(
            {
              title: 'Delete Question List?',
              message: 'Are you sure you want to delete this question list?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;

              questionListService.deleteQuestionList($scope.data.question_list_id).then(
                () => {
                  flashService.set('<span class="fa fa-check"></span> Question list deleted.', 'success');
                  $state.go('v1.questionLists');
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  $scope.processing = false;
                },
              );
            },
            () => {},
          );
      },
      submit() {
        $scope.submitted = true;
        // prepend http to privacy policy url if it doesnt have it
        if ($scope.viewmodel.privacy_policy_url) {
          const urlPattern = /^((http|https):\/\/)/;
          if (!urlPattern.test($scope.viewmodel.privacy_policy_url)) {
            $scope.viewmodel.privacy_policy_url = `http://${$scope.viewmodel.privacy_policy_url}`;
          }
        }

        $('.tabs-fixed > .nav-tabs > .uib-tab').removeClass('has-error');

        for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
          $scope.viewmodel.questions[i].has_error = false;
        }

        if ($scope.viewmodel.game_type === 'jeopardy') {
          for (let i = 0; i < $scope.viewmodel.question_groups.length; i++) {
            for (let j = 0; j < $scope.viewmodel.question_groups[i].question_groups.length; j++) {
              const category = $scope.viewmodel.question_groups[i].question_groups[j];
              category.has_error = false;

              for (let k = 0; k < category.questions.length; k++) {
                category.questions[k].has_error = false;
              }
            }
          }
        }

        for (let i = 0; i < $scope.data.existingTranslations.length; i++) {
          $scope.data.existingTranslations[i].has_error = false;
        }

        if ($scope.questionListForm.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );

          const field = $(':input.ng-invalid:visible:first');

          if (field.length) {
            $('html, body')
              .stop(true, false)
              .animate(
                {
                  scrollTop: field.parent().offset().top - 110,
                },
                450,
              );
          }

          $('.tabs-fixed > .tab-content > .tab-pane').each(function (i) {
            if ($(this).find('.ng-invalid').length) {
              $('.tabs-fixed > .nav-tabs > .uib-tab')
                .eq(i)
                .addClass('has-error');
            }
          });

          $('.translation').each(function (i) {
            if ($(this).find('.ng-invalid').length) {
              $scope.data.existingTranslations[i].has_error = true;
            }
          });

          if ($scope.viewmodel.questions.length) {
            $('.panel-group .panel').each(function (i) {
              if ($(this).find('.ng-invalid').length) {
                $scope.viewmodel.questions[i].has_error = true;
              }
            });
          }

          if ($scope.viewmodel.game_type === 'jeopardy') {
            $('#parent-group > .panel').each(function (i) {
              $('.category-group', this).each(function (j) {
                $('.panel-group .panel', this).each(function (k) {
                  if ($(this).find('.ng-invalid').length) {
                    $scope.viewmodel.question_groups[i].question_groups[j].has_error = true;
                    $scope.viewmodel.question_groups[i].question_groups[j].questions[k].has_error = true;
                  }
                });
              });
            });
          }

          if (!field.length) {
            const panel = $('.panel-group .panel-danger:visible:first');

            if (panel.length) {
              $('html, body')
                .stop(true, false)
                .animate(
                  {
                    scrollTop: panel.offset().top - 120,
                  },
                  450,
                );
            }
          }

          return;
        }

        $scope.processing = true;

        const gameData = _.cloneDeep($scope.viewmodel); // Using underscore because angular.copy destroys File objects

        // Flatten grid answer rows
        if (gameData.game_type === 'grid') {
          const { questions } = gameData;
          for (let i = 0; i < questions.length; i++) {
            const question = questions[i];
            // eslint-disable-next-line prefer-spread
            const flattenedAnswers = [].concat.apply([], question.answers);
            question.answers = flattenedAnswers;
          }
        }
        // Adding new game
        // eslint-disable-next-line consistent-return
        return questionListService.addQuestionList(gameData).then(
          (questionList) => {
            $scope.viewmodel = questionList;
            $scope.actions.processGame($scope.viewmodel);
            const msg = $scope.data.question_list_id ? 'updated' : 'created';
            if ($scope.data.question_list_id) {
              $scope.actions.createAlert(
                `<span class="fa fa-check"></span> Question list ${msg} successfully.`,
                'success',
              );
              $state.go('v1.editQuestionList', { question_list_id: questionList.question_list_id });
              $scope.processing = false;
            } else {
              flashService.set(`<span class="fa fa-check"></span> Question list ${msg} successfully.`, 'success');
              $state.go('v1.editQuestionList', { question_list_id: questionList.question_list_id });
            }
          },
          (error) => {
            if (error.message) {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            } else {
              $scope.actions.createAlert(
                '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                'danger',
              );
            }

            if (error.fields) {
              for (let i = 0; i < error.fields.length; i++) {
                if ($scope.questionListForm[error.fields[i]]) {
                  $scope.questionListForm[error.fields[i]].$setValidity('required', false);
                }
              }
            }

            $scope.processing = false;
          },
        );
      },
      copyGame() {
        modalService
          .showModal(
            {
              title: 'Copy Game?',
              // eslint-disable-next-line max-len
              message: '<strong>Step 1:</strong> Click "Copy Game".  Important reminder:  please save the game you are currently editing before copying.',
              closeButton: 'Cancel',
              actionButton: 'Copy Game',
              actionClass: 'primary',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              // reset the game ID
              $scope.data.gameId = null;
              // get rid of keys that get added when you create a game
              delete $scope.viewmodel.game_id;
              delete $scope.viewmodel.ext_game_id;
              delete $scope.viewmodel.date_created;
              // rename the game and slug
              $scope.viewmodel.name = `${$scope.viewmodel.name} copy`;
              $scope.viewmodel.slug = `${$scope.viewmodel.slug}-copy`;
              flashService.set('<span class="fa fa-check"></span> Please click "Save".', 'warning');
              // go to add game page and pass in viewmodel and data copies
              $state.go('v1.addGame', {
                type: $scope.viewmodel.game_type,
                viewmodel: $scope.viewmodel,
                data: $scope.data,
              });
            },
            () => {},
          );
      },
      hasInterstitials() {
        if ($scope.viewmodel.game_type === 'trivia' || $scope.viewmodel.game_type === 'grid') {
          for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
            if ($scope.viewmodel.questions[i].question_type === 'interstitial') {
              // hides the randomize question field
              $scope.hasInterstitial = true;
              return;
            }
          }

          // if no interstitials - show the randomize question field
          $scope.hasInterstitial = false;
        }
      },
      processGame(game, successAlert) {
        if (successAlert) {
          $scope.actions.createAlert(
            '<span class="fa fa-check"></span> Question list updated successfully.',
            'success',
          );
        }

        if (game.game_type === 'grid') {
          game = $scope.actions.formatGridGame(game);
        }

        $scope.processing = false;

        $scope.viewmodel.questions.forEach((question) => {
          $scope.actions.changeQuestionType(question);
        });

        if ($scope.viewmodel.game_type === 'jeopardy') {
          for (let i = 0; i < $scope.viewmodel.question_groups.length; i++) {
            for (let j = 0; j < $scope.viewmodel.question_groups[i].question_groups.length; j++) {
              const category = $scope.viewmodel.question_groups[i].question_groups[j];

              for (let k = 0; k < category.questions.length; k++) {
                $scope.actions.changeQuestionType(category.questions[k]);

                if (category.questions[k].time > 0) {
                  category.questions[k].useTimer = true;
                } else {
                  category.questions[k].useTimer = false;
                }
              }
            }
          }
        } else if ($scope.viewmodel.game_type === 'recall') {
          for (let i = 0; i < $scope.viewmodel.question_groups.length; i++) {
            if ($scope.viewmodel.question_groups[i].time > 0) {
              $scope.viewmodel.question_groups[i].useTimer = true;
            } else {
              $scope.viewmodel.question_groups[i].useTimer = false;
            }

            const question_group = $scope.viewmodel.question_groups[i];

            for (let j = 0; j < question_group.questions.length; j++) {
              $scope.actions.changeQuestionType(question_group.questions[j]);
            }
          }
        } else {
          for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
            if ($scope.viewmodel.questions[i].time > 0) {
              $scope.viewmodel.questions[i].useTimer = true;
            } else {
              $scope.viewmodel.questions[i].useTimer = false;
            }
          }
        }
        // @TODO leave for now
        $scope.actions.updateBranchOptions();
        $scope.actions.filterLanguages(game);

        $scope.submitted = false;
      },
      filterLanguages(game) {
        // filter the available languages
        $scope.data.existingTranslations = [];
        for (let i = 0; i < $scope.viewmodel.available_translations.length; i++) {
          delete $scope.data.availableTranslations[$scope.viewmodel.available_translations[i].language_id];

          if ($scope.viewmodel.available_translations[i].language_id !== game.language_id) {
            $scope.data.existingTranslations.push($scope.viewmodel.available_translations[i]);
          }
        }

        [$scope.data.activeTranslation] = $scope.data.existingTranslations;
      },
      addQuestion(qType) {
        if ($scope.viewmodel.game_type === 'grid' && qType !== 'interstitial') {
          $scope.actions.addGridQuestion();
          return;
        }

        $scope.data.limit = 500;

        const { lastQuestionType } = $scope.data;
        let questionType;

        if (qType === 'interstitial') {
          questionType = 'interstitial';
        } else if (lastQuestionType === 'interstitial') {
          questionType = 'multiple_choice';
        } else if (lastQuestionType) {
          questionType = lastQuestionType;
        } else {
          questionType = $scope.viewmodel.game_type === 'scramble' ? 'scramble_letter' : 'multiple_choice';
        }

        let answers = [];

        if (qType !== 'interstitial') {
          answers = [
            {
              answer_id: null,
              text: null,
              match_type: null,
              image: null,
              response: null,
              correct: false,
              translations: {},
              points: null,
              next_question_hash: null,
            },
            {
              answer_id: null,
              text: null,
              match_type: null,
              image: null,
              response: null,
              correct: false,
              translations: {},
              points: null,
              next_question_hash: null,
            },
          ];
        }

        const question = {
          question_id: null,
          question_type: questionType,
          question_group: null,
          text: null,
          image: null,
          audio: null,
          video: null,
          watch_video: null,
          response_correct: null,
          response_incorrect: null,
          response_timeout: null,
          response_correct_image: null,
          response_incorrect_image: null,
          response_timeout_image: null,
          show_results: null,
          useTimer: $scope.viewmodel.useGlobalTimer,
          time: $scope.viewmodel.time_per_question,
          randomize_answers: true,
          interstitial: {
            name: null,
            text_color: questionType === 'interstitial' ? '#000000' : null,
            text_shadow: false,
            bg_color: questionType === 'interstitial' ? '#F2F5F9' : null,
          },
          answers,
          translations: {},
          hash: null,
          next_question_hash_correct: null,
          next_question_hash_incorrect: null,
          next_question_hash_timeout: null,
          points_correct: null,
          points_incorrect: null,
        };

        $scope.actions.changeQuestionType(question);
        $scope.viewmodel.questions.push(question);
        $scope.actions.toggleCollapse($scope.viewmodel.questions.length - 1);
        $scope.actions.updateBranchOptions();
      },
      addGridQuestion() {
        $scope.data.limit = 500;

        const question = {
          question_id: null,
          question_type: 'grid',
          question_group: null,
          text: null,
          image: null,
          audio: null,
          video: null,
          watch_video: null,
          response_correct: null,
          response_incorrect: null,
          response_timeout: null,
          response_correct_image: null,
          response_incorrect_image: null,
          response_timeout_image: null,
          show_results: null,
          useTimer: $scope.viewmodel.useGlobalTimer,
          time: $scope.viewmodel.time_per_question,
          randomize_answers: true,
          interstitial: {
            name: null,
            text_color: null,
            text_shadow: false,
            bg_color: null,
          },
          answers: [
            [
              {
                answer_id: null,
                type: null,
                match_type: null,
                text: null,
                image: null,
                response: null,
                correct: false,
                row: 0,
                col: 0,
                points: null,
              },
              {
                answer_id: null,
                type: null,
                match_type: null,
                text: null,
                image: null,
                response: null,
                correct: false,
                row: 0,
                col: 1,
                points: null,
              },
              {
                answer_id: null,
                type: null,
                match_type: null,
                text: null,
                image: null,
                response: null,
                correct: false,
                row: 0,
                col: 2,
                points: null,
              },
            ],
          ],
          column_titles: [
            {
              text: '',
              index: 0,
            },
            {
              text: '',
              index: 1,
            },
            {
              text: '',
              index: 2,
            },
          ],
          row_titles: [
            {
              text: '',
              index: 0,
            },
          ],
        };

        $scope.actions.changeQuestionType(question);
        $scope.viewmodel.questions.push(question);
        $scope.actions.toggleCollapse($scope.viewmodel.questions.length - 1);
      },
      addBranchOption(question) {
        question.hash = question.hash || uuidv4();
        let suffixString;
        if (question.question_type === 'interstitial') {
          suffixString = question.interstitial.name !== null ? `: ${question.interstitial.name}` : '';
        } else {
          suffixString = question.text !== null ? `: ${question.text}` : '';
        }

        const typeString = question.question_type === 'interstitial' ? 'Interstitial' : 'Question';
        const displayText = `${$scope.data.branchingOptions.length}. ${typeString}${suffixString}`;

        $scope.data.branchingOptions.push({
          displayText,
          hash: question.hash,
        });
      },
      updateBranchOptions(removedHash) {
        $scope.data.branchingOptions = [
          {
            displayText: 'Next Question',
            hash: null,
          },
        ];

        $scope.viewmodel.questions.forEach((question) => {
          $scope.actions.addBranchOption(question);
        });

        $scope.data.branchingOptions.push({
          displayText: 'End Game',
          hash: '-1',
        });

        if (removedHash) {
          for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
            const question = $scope.viewmodel.questions[i];

            if (question.next_question_hash_correct === removedHash) {
              question.next_question_hash_correct = null;
            }

            if (question.next_question_hash_incorrect === removedHash) {
              question.next_question_hash_incorrect = null;
            }

            for (let j = 0; j < question.answers.length; j++) {
              if (question.answers[j].next_question_hash === removedHash) {
                question.answers[j].next_question_hash = null;
              }
            }
          }
        }
      },
      toggleCollapse(index) {
        if ($scope.data.isOpen[index]) {
          $scope.data.isOpen.length = 0;
          return;
        }

        $scope.data.isOpen.length = 0;
        $scope.data.isOpen[index] = true;
        $timeout(() => {
          $('html, body')
            .stop(true, false)
            .animate(
              {
                scrollTop:
                  $('#parent-group')
                    .children('.panel')
                    .eq(index)
                    .offset().top - 120,
              },
              250,
            );
        }, 10);
      },
      moveQuestion(from, to) {
        $scope.viewmodel.questions.splice(to, 0, $scope.viewmodel.questions.splice(from, 1)[0]);

        if ($scope.data.isOpen[from]) {
          $scope.data.isOpen.length = 0;
          $scope.data.isOpen[to] = true;
        } else if ($scope.data.isOpen[to]) {
          $scope.data.isOpen.length = 0;
          $scope.data.isOpen[from] = true;
        }

        $scope.actions.updateBranchOptions();
      },
      addAnswer(question) {
        question.answers.push({
          answer_id: null,
          type: null,
          match_type: null,
          text: null,
          image: null,
          response: null,
          correct: false,
          translations: {},
          next_question_hash: null,
          points: null,
        });
      },
      addGridRow(question) {
        const row_num = question.answers.length;
        const newgridrow = [];
        for (let i = 0; i < question.answers[0].length; i++) {
          newgridrow.push({
            answer_id: null,
            type: null,
            match_type: null,
            text: null,
            image: null,
            response: null,
            correct: false,
            row: row_num,
            col: i,
            points: null,
          });
        }
        question.answers.push(newgridrow);

        question.row_titles.push({
          text: '',
          index: row_num,
        });
      },
      deleteGridRow(question, index) {
        question.answers.splice(index, 1);
        question.row_titles.splice(index, 1);
      },
      deleteGridColumn(question, index) {
        for (let i = 0; i < question.answers.length; i++) {
          question.answers[i].splice(index, 1);
        }
        question.column_titles.splice(index, 1);
      },
      addGridColumn(question) {
        const row_num = question.answers.length;

        const colCount = question.answers[0].length;

        for (let i = 0; i < row_num; i++) {
          question.answers[i].push({
            answer_id: null,
            type: null,
            match_type: null,
            text: null,
            image: null,
            response: null,
            correct: false,
            row: row_num,
            col: colCount + 1,
            points: null,
          });
        }

        question.column_titles.push({
          text: '',
          index: question.column_titles.length + 1,
        });
      },
      answerTypeChanged(answer) {
        switch (answer.type) {
          case 'image':
            answer.text = null;
            break;
          case 'text':
            answer.image = null;
            break;
          case 'empty':
            answer.text = null;
            answer.image = null;
            break;
          default:
            break;
        }
      },
      deleteQuestion(question) {
        const questionHash = question.hash;

        if (question.question_id === null) {
          $scope.viewmodel.questions.splice($scope.viewmodel.questions.indexOf(question), 1);
          $scope.actions.updateBranchOptions(questionHash);
          return;
        }

        modalService
          .showModal(
            {
              title: 'Delete Question?',
              message:
              // eslint-disable-next-line max-len
                'Are you sure you want to delete this question? All analytics data associated with the question will be permanently deleted.',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.viewmodel.questions.splice($scope.viewmodel.questions.indexOf(question), 1);
              $scope.data.isOpen.length = 0;
              $scope.actions.updateBranchOptions(questionHash);
              $scope.actions.hasInterstitials();
            },
            () => {},
          );
      },
      selectAuthorizationType() {
        switch ($scope.viewmodel.authorization_type) {
          case 0:
            $scope.viewmodel.user_list_id = null;
            $scope.viewmodel.sso_provider_id = null;
            break;
          case 1:
            $scope.viewmodel.sso_provider_id = null;
            break;
          case 2:
            $scope.viewmodel.user_list_id = null;
            break;
          default:
            break;
        }
      },
      changeQuestionType(question) {
        const totalAnswers = question.answers.length;

        // Set min/max answers
        if (question.question_type === 'slider') {
          question.min_answers = 2;
          question.max_answers = 5;
        } else if (question.question_type === 'image') {
          question.min_answers = 2;
          question.max_answers = 4;
        } else if (question.question_type === 'text_input') {
          question.min_answers = 1;
          question.max_answers = 10;
        } else if (question.question_type === 'grid') {
          question.min_answers = 1;
          question.max_answers = 6;
        } else if (question.question_type === 'scramble_letter' || question.question_type === 'scramble_sentence') {
          question.min_answers = 1;
          question.max_answers = 1;
        } else if (question.question_type === 'interstitial') {
          question.min_answers = 0;
          question.max_answers = 0;
        } else if (question.question_type === 'poll') {
          question.min_answers = 2;
          question.max_answers = 4;

          if ($scope.viewmodel.game_type === 'scenarios') {
            question.max_answers = 6;
          }
        } else {
          question.min_answers = 2;
          question.max_answers = 4;
        }

        // WBS question overrides
        if ($scope.viewmodel.game_type === 'wbs') {
          if (question.question_type === 'image') {
            question.max_answers = 14;
          }
          if (question.question_type === 'multiple_choice') {
            question.min_answers = 1;
            question.max_answers = 1;
          }
          if (question.question_type === 'poll') {
            question.max_answers = 6;
          }
        }

        // Set image vs text
        if (question.question_type === 'image' && $scope.viewmodel.game_type !== 'wbs') {
          for (let i = 0; i < totalAnswers; i++) {
            question.answers[i].text = null;
          }
        } else if ($scope.viewmodel.game_type !== 'wbs') {
          for (let i = 0; i < totalAnswers; i++) {
            question.answers[i].image = null;
          }
        }

        // Set max correct
        if (question.question_type === 'multiple_select' || question.question_type === 'image') {
          question.max_correct = null;
        } else {
          question.max_correct = 1;

          const totalCorrect = $filter('filter')(
            question.answers,
            {
              correct: true,
            },
            true,
          ).length;

          if (totalCorrect > 1 || question.question_type === 'poll') {
            for (let i = 0; i < totalAnswers; i++) {
              question.answers[i].correct = false;
            }
          }
        }

        // if not poll unset show_results
        if (question.question_type !== 'poll') {
          question.show_results = null;

          if (question.question_type !== 'multiple_choice') {
            for (let i = 0; i < totalAnswers; i++) {
              question.answers[i].points = null;
            }
          }
        }

        // if poll or multiple choice points are set on the answers
        if (question.question_type === 'poll' || question.question_type === 'multiple_choice') {
          question.points_correct = null;
          question.points_incorrect = null;
        }

        if (question.answers.length > question.max_answers) {
          // Remove excess answers based on new max_answers
          question.answers.splice(question.max_answers, question.answers.length - question.max_answers);
        } else if (question.answers.length < question.min_answers) {
          // Add answers if below min_answers
          for (let i = 0; i < question.min_answers - question.answers.length; i++) {
            question.answers.push({
              answer_id: null,
              match_type: null,
              text: null,
              image: null,
              response: null,
              correct: false,
              points: null,
              next_question_hash: null,
            });
          }
        }

        // if it is not multiple choice we have to set the next_question_hash
        // on the anwswers to null because the next question id will come from the question
        if (question.question_type !== 'multiple_choice' && question.question_type !== 'poll') {
          for (let i = 0; i < question.answers.length; i++) {
            question.answers[i].next_question_hash = null;
          }
        }

        $scope.data.lastQuestionType = question.question_type;

        // Check for interstitials
        $scope.actions.hasInterstitials();
      },
      globalTimerCheck() {
        if ($scope.viewmodel.useGlobalTimer) {
          $scope.viewmodel.time_per_question = !$scope.viewmodel.time_per_question
            ? 60
            : $scope.viewmodel.time_per_question;
        } else {
          $scope.viewmodel.time_per_question = null;
        }
      },
      questionTimerCheck(question) {
        if (question.useTimer) {
          question.time = $scope.viewmodel.time_per_question;
        } else {
          question.time = null;
          question.next_question_hash_timeout = null;
          question.response_timeout = null;
        }
      },
      checkImage(image) {
        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          image = null;
          // image.invalid_size = true;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      checkAudio(audio) {
        const allowed = /audio\/mpeg|audio\/mp3/.test(audio.file.type);

        if (!allowed) {
          audio = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (audio.file.size > 5242880) {
          audio = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Audio files cannot be more than 5 MB in size.',
            'danger',
          );
          return;
        }

        fileReader.readAsDataUrl(audio.file, $scope).then((result) => {
          audio.base64 = result;
          audio.filetype = audio.file.type;
          audio.filename = audio.file.name;
        });
      },
      checkVideo(video) {
        const allowed = /video\/mp4/.test(video.file.type);

        if (!allowed) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        if (video.file.size > 104857600) {
          video.file = null; // this is needed for some reason
          video = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Video files cannot be more than 30 MB in size.',
            'danger',
          );
          return;
        }

        video.url = URL.createObjectURL(video.file);
      },
      videoEmbed(video) {
        if (video.url.includes('vimeo')) {
          const result = video.url.match(
            // eslint-disable-next-line max-len
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
          );
          video.url = `https://player.vimeo.com/video/${result[1]}`;
        } else if (video.url.includes('youtu')) {
          if (!video.url.includes('embed')) {
            const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
            video.url = `https://www.youtube.com/embed/${video.url.match(expr)[2]}`;
          }
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      tabChanged() {
        $window.scrollTo(0, 0);
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      changeGlobalTimePerQuestion() {
        if ($scope.viewmodel.game_type === 'recall') {
          for (let i = 0; i < $scope.viewmodel.question_groups.length; i++) {
            if ($scope.viewmodel.question_groups[i].useTimer) {
              $scope.viewmodel.question_groups[i].time = $scope.viewmodel.time_per_question;
            }
          }
        } else {
          for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
            if ($scope.viewmodel.questions[i].useTimer) {
              $scope.viewmodel.questions[i].time = $scope.viewmodel.time_per_question;
            }
          }
        }
      },
      addTranslation() {
        const { selectedTranslation } = $scope.data;
        $scope.data.activeTranslation = $scope.data.selectedTranslation;

        $scope.data.existingTranslations.push(selectedTranslation);
        $scope.data.existingTranslations = $filter('orderBy')($scope.data.existingTranslations, 'name', false);

        delete $scope.data.availableTranslations[selectedTranslation.language_id];

        $scope.data.selectedTranslation = null;
      },
      activateTranslation(translation) {
        $scope.data.activeTranslation = translation;
      },
      deleteTranslation(languageId) {
        const translation = $scope.data.allTranslations[languageId];
        $scope.data.availableTranslations[translation.language_id] = translation;

        for (let i = 0; i < $scope.data.existingTranslations.length; i++) {
          const e = $scope.data.existingTranslations[i];
          if (e.language_id === translation.language_id) {
            $scope.data.existingTranslations.splice(i, 1);
            break;
          }
        }

        // Delete question translations
        for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
          const question = $scope.viewmodel.questions[i];
          delete question.translations[translation.language_id];

          for (let j = 0; j < question.answers.length; j++) {
            const answer = question.answers[j];
            delete answer.translations[translation.language_id];
          }
        }

        // Delete question_group translations
        for (let g = 0; g < $scope.viewmodel.question_groups.length; g++) {
          const question_group = $scope.viewmodel.question_groups[g];
          delete question_group.translations[translation.language_id];

          for (let i = 0; i < question_group.questions.length; i++) {
            const question = question_group.questions[i];
            delete question.translations[translation.language_id];

            for (let j = 0; j < question.answers.length; j++) {
              const answer = question.answers[j];
              delete answer.translations[translation.language_id];
            }
          }
        }

        if ($scope.data.existingTranslations.length > 0) {
          [$scope.data.activeTranslation] = $scope.data.existingTranslations;
        } else {
          $scope.data.activeTranslation = null;
        }
      },
      changeDefaultLanguage(currentLanguageId) {
        const defaultLanguage = $scope.viewmodel.language_id;
        $scope.data.availableTranslations = angular.copy($scope.data.allTranslations);

        currentLanguageId = parseInt(currentLanguageId, 10);

        const generateCurrLangTranslation = angular.isUndefined($scope.data.existingTranslations.find(
          (id) => id.language_id === currentLanguageId,
        ));

        if (generateCurrLangTranslation) {
          // add current language data as a translation
          $scope.data.selectedTranslation = $scope.data.allTranslations[currentLanguageId];
          $scope.actions.addTranslation();
          for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
            const question = $scope.viewmodel.questions[i];
            question.translations[currentLanguageId] = {
              text: question.text,
            };
            for (let j = 0; j < question.answers.length; j++) {
              const answer = question.answers[j];
              answer.translations[currentLanguageId] = {
                text: answer.text,
              };
            }
          }
          for (let g = 0; g < $scope.viewmodel.question_groups.length; g++) {
            const question_group = $scope.viewmodel.question_groups[g];
            question_group.translations[currentLanguageId] = {
              image: question_group.image,
              video: question_group.video,
            };
            for (let i = 0; i < question_group.questions.length; i++) {
              const question = question_group.questions[i];
              question.translations[currentLanguageId] = {
                text: question.text,
              };

              for (let j = 0; j < question.answers.length; j++) {
                const answer = question.answers[j];
                answer.translations[currentLanguageId] = {
                  text: answer.text,
                };
              }
            }
          }
        }

        const translationExists = angular.isDefined($scope.data.existingTranslations.find((id) => id.language_id === defaultLanguage));

        if (translationExists) {
          // apply translation data to questions
          for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
            const question = $scope.viewmodel.questions[i];
            question.text = question.translations[defaultLanguage].text;

            for (let j = 0; j < question.answers.length; j++) {
              const answer = question.answers[j];
              answer.text = answer.translations[defaultLanguage].text;
            }
          }
          for (let g = 0; g < $scope.viewmodel.question_groups.length; g++) {
            const question_group = $scope.viewmodel.question_groups[g];
            if (question_group.image) {
              question_group.image = question_group.translations[defaultLanguage].image;
            }
            if (question_group.video) {
              question_group.video = question_group.translations[defaultLanguage].video;
            }
            for (let i = 0; i < question_group.questions.length; i++) {
              const question = question_group.questions[i];
              question.text = question.translations[defaultLanguage].text;
              for (let j = 0; j < question.answers.length; j++) {
                const answer = question.answers[j];
                answer.text = answer.translations[defaultLanguage].text;
              }
            }
          }
        }

        for (let i = 0; i < $scope.data.existingTranslations.length; i++) {
          delete $scope.data.availableTranslations[$scope.data.existingTranslations[i].language_id];
        }

        delete $scope.data.availableTranslations[$scope.viewmodel.language_id];
        $scope.data.activeTranslation = $scope.data.allTranslations[currentLanguageId];
      },
      presentTemplateModal() {
        const csvData = [];
        // loop through available translations and create headers
        const csvHeader = ['', 'Default Language'];

        const translations = angular.copy($scope.data.allTranslations);

        delete translations[$scope.viewmodel.language_id];

        const translationKeys = Object.keys(translations);

        for (let i = 0; i < translationKeys.length; i++) {
          const key = translationKeys[i];
          const translation = $scope.data.allTranslations[key];
          const headerString = `${translation.name} [${translation.language_id}]`;
          csvHeader.push(headerString);
        }
        csvData.push(csvHeader);

        let rowData = [];

        // loop through questions to create rows
        for (let i = 0; i < $scope.viewmodel.questions.length; i++) {
          const question = $scope.viewmodel.questions[i];

          rowData = [];

          const questionString = `Question ${i + 1}`;

          rowData.push(questionString);

          if (question.translations) {
            rowData.push(question.text);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].text);
              } else {
                rowData.push(null);
              }
            }
          }

          csvData.push(rowData);

          if (question.response_correct) {
            rowData = [];
            rowData.push('Feedback Correct');
            rowData.push(question.response_correct);
            // rowData.push(question.response_correct_image);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].response_correct);
                // rowData.push(question.translations[key].response_correct_image);
              } else {
                rowData.push(null);
                // rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          if (question.response_incorrect) {
            rowData = [];
            rowData.push('Feedback Incorrect');
            rowData.push(question.response_incorrect);
            // rowData.push(question.response_incorrect_image);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].response_incorrect);
                // rowData.push(question.translations[key].response_incorrect_image);
              } else {
                rowData.push(null);
                // rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          if (question.response_timeout) {
            rowData = [];
            rowData.push('Feedback Timeout');
            rowData.push(question.response_timeout);
            // rowData.push(question.response_timeout_image);

            for (let j = 0; j < translationKeys.length; j++) {
              const key = translationKeys[j];

              if (question.translations[key]) {
                rowData.push(question.translations[key].response_timeout);
                // rowData.push(question.translations[key].response_timeout_image);
              } else {
                rowData.push(null);
                // rowData.push(null);
              }
            }

            csvData.push(rowData);
          }

          const { answers } = question;

          for (let j = 0; j < answers.length; j++) {
            const answer = answers[j];

            const answerString = `Answer ${j + 1}`;
            rowData = [];

            rowData.push(answerString);
            rowData.push(answer.text);

            for (let k = 0; k < translationKeys.length; k++) {
              const key = translationKeys[k];
              if (answer.translations[key]) {
                rowData.push(answer.translations[key].text);
              } else {
                rowData.push(null);
              }
            }

            csvData.push(rowData);
          }
        }

        const defaults = {
          backdrop: 'static',
          keyboard: false,
          animation: true,
          templateUrl: 'templates/partials/game/game_translation_modal.html',
          size: null,
        };

        const options = {
          title: 'Translation Template',
          closeButton: 'Cancel',
          actionButton: false,
          template: null,
          csv: csvData,
        };

        modalService.showModal(options, defaults).then(
          (result) => {
            if (result.type === 'upload') {
              let showAlert = false;

              $scope.actions.submit(showAlert).then(() => {
                gameService.uploadTranslation($scope.viewmodel, result.files).then(
                  (game) => {
                    showAlert = true;
                    $scope.actions.processGame(game, showAlert);
                  },
                  (error) => {
                    $scope.actions.createAlert(
                      `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                      'danger',
                    );
                  },
                );
              });
            }
          },
          () => {},
        );
      },
      formatGridGame(game) {
        const { questions } = game;

        for (let i = 0; i < questions.length; i++) {
          if (questions[i].question_type === 'grid') {
            const question = questions[i];
            const { answers } = question;
            const formattedAnswers = [];
            let answerRow = [];
            for (let j = 0; j < answers.length; j++) {
              const answer = answers[j];
              answerRow.push(answer);
              if ((j + 1) % question.column_titles.length === 0) {
                formattedAnswers.push(answerRow);
                answerRow = [];
              }
            }
            question.answers = formattedAnswers;
          }
        }

        return game;
      },
      forceHex(model, prop) {
        if (!model[prop]) {
          return;
        }

        if (model[prop][0] !== '#') {
          model[prop] = `#${model[prop]}`;
        }

        if (model[prop].length !== 7) {
          model[prop] = null;
        }
      },
      clearHex(model, prop) {
        model[prop] = null;
      },
      ingest(event) {
        const reader = new FileReader();
        reader.onload = function (fileLoadedEvent) {
          const textFromFileLoaded = fileLoadedEvent.target.result;
          $scope.viewmodel.questions = textFromFileLoaded;
          $scope.loading = true;

          questionListService
            .uploadJSON($scope.viewmodel)
            .then((questionList) => {
              flashService.set('<span class="fa fa-check"></span> Question list created.', 'success');
              $state.go('v1.editQuestionList', { question_list_id: questionList.question_list_id });
              $scope.loading = false;
            })
            .catch((error) => {
              if (error.message) {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
              } else {
                $scope.actions.createAlert(
                  '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                  'danger',
                );
              }
              $scope.viewmodel.questions = [];
              $scope.loading = false;
            });
        };
        reader.readAsText(event.target.files[0]);
      },
    };

    $scope.initialize();
  },
]);
